<template>
  <section class="service-section">
    <div class="service-container">
      <ServicePackagesSidebar />
      <div class="content-col">
        <ServicePackageContent
          title="Shopify Migration Package"
          startingPrice="$19,999"
          :overview="overview"
          :bullets="bullets"
          cta-route="/schedule-a-meeting"
        />
        <MobileServicePackagesList />
      </div>
    </div>
  </section>
</template>

<script>
import ServicePackagesSidebar from '@/views/servicePackages/ServicePackagesSidebar.vue';
import ServicePackageContent from '@/views/servicePackages/ServicePackageContent.vue';
import MobileServicePackagesList from '@/views/servicePackages/MobileServicePackagesList.vue';

export default {
  name: 'ShopifyMigration',
  components: {
    ServicePackagesSidebar,
    ServicePackageContent,
    MobileServicePackagesList,
  },
  data() {
    return {
      overview:
        'We migrate your existing e-commerce site to Shopify, giving you a stable, scalable, and easy-to-manage platform. Ideal for businesses moving away from custom builds, WooCommerce, Magento, or outdated systems.',
      bullets: [
        'Migration of product catalog, customers, orders, and media assets',
        'Checkout, payment, and shipping flows rebuilt on Shopify',
        'SEO preservation (redirects, metadata, rankings)',
        'Minimal downtime and smooth customer experience',
        'Future-ready foundation for growth',
      ],
    };
  },
};
</script>

<style scoped>
.service-section {
  padding: 2rem 1rem;
  background: #f9fafb;
}

/* Two-column layout: fixed 380px sidebar + flexible content */
.service-container {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

/* Wrap content and ensure it can shrink without overflow */
.content-col {
  min-width: 0;
}

/* One-column at ≤768px (sidebar hidden by its own CSS) */
@media (max-width: 768px) {
  .service-container {
    grid-template-columns: 1fr;
  }
}
</style>
